import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { toast } from "sonner";
import { Check } from "lucide-react";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const nav = useNavigate();
    const [pw, setPw] = useState("");
    const [pw2, setPw2] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    async function submit(e) {
        e.preventDefault();
        if (pw.length < 6) return toast.error("Mínimo 6 caracteres");
        if (pw !== pw2) return toast.error("As palavras-passe não coincidem");
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: pw });
            setDone(true);
            setTimeout(() => nav("/login"), 2200);
        } catch (e) {
            toast.error(formatErr(e.response?.data?.detail));
        } finally {
            setBusy(false);
        }
    }

    return (
        <>
            <Navbar />
            <section className="pt-32 pb-24 bg-cream min-h-[80vh]">
                <div className="container-edge max-w-md mx-auto">
                    <span className="label-overline text-wine">Conta</span>
                    <h1 className="mt-4 font-heading text-5xl text-wine-dark">Nova palavra-passe</h1>

                    {done ? (
                        <div className="mt-10 bg-white border border-vineyard/40 rounded-md p-6 shadow-sm text-center">
                            <Check className="h-12 w-12 text-vineyard mx-auto" strokeWidth={1.5} />
                            <h2 className="mt-4 font-heading text-2xl text-wine-dark">Palavra-passe atualizada</h2>
                            <p className="mt-2 text-sm text-wine-dark/70">A redirecionar para o login…</p>
                        </div>
                    ) : (
                        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="reset-form">
                            <label className="block">
                                <span className="label-overline text-wine-dark">Nova palavra-passe</span>
                                <input
                                    type="password"
                                    value={pw}
                                    onChange={(e) => setPw(e.target.value)}
                                    required
                                    minLength={6}
                                    className="mt-2 w-full bg-transparent border border-wine-dark/20 rounded-md px-4 py-3 text-sm focus:border-wine"
                                    data-testid="reset-pw"
                                />
                            </label>
                            <label className="block">
                                <span className="label-overline text-wine-dark">Confirmar</span>
                                <input
                                    type="password"
                                    value={pw2}
                                    onChange={(e) => setPw2(e.target.value)}
                                    required
                                    minLength={6}
                                    className="mt-2 w-full bg-transparent border border-wine-dark/20 rounded-md px-4 py-3 text-sm focus:border-wine"
                                    data-testid="reset-pw2"
                                />
                            </label>
                            <button disabled={busy || !token} className="btn-wine w-full" data-testid="reset-submit">
                                {busy ? "A atualizar…" : "Atualizar palavra-passe"}
                            </button>
                            {!token && (
                                <p className="text-xs text-destructive">Token em falta no URL. Solicite um novo link.</p>
                            )}
                        </form>
                    )}

                    <div className="mt-8 text-sm text-wine-dark/70">
                        <Link to="/login" className="text-wine font-semibold hover:text-gold-deep">
                            ← Voltar ao login
                        </Link>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}
